import { isBefore, startOfDay } from 'date-fns'

/**
 * Whether an appointment lies in the past for the detail screen, which then keeps its facts and
 * related items and drops the actions (contact, waitlist, cancel) and the kiosk hint.
 *
 * "Past" means an earlier day than today: an appointment later today, or earlier today, keeps its
 * actions, because the patient may still need them on the day itself. The other rules each have
 * their own moment: cancelling closes at the deadline (canCancelAppointment), the waitlist at the
 * exact start (canShowWaitlist). An admission is over by its end (isFinishedEncounter).
 */
function isPastAppointment(start: string | Date, now: Date = new Date()): boolean {
  return isBefore(new Date(start), startOfDay(now))
}

export { isPastAppointment }
